exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".result-download-progess-wrapper[data-v-160e56d8]{height:100%;font-size:15px}.result-download-progess-wrapper .close-button[data-v-160e56d8]{position:absolute;right:20px;bottom:20px}.fail-files-wrapper[data-v-160e56d8]{height:110px;overflow-y:scroll;border:1px solid #cecece;margin-top:4px;padding:4px}", ""]);

// exports
